import { render } from "./PreActionOffers.vue?vue&type=template&id=d0f970e4&scoped=true"
import script from "./PreActionOffers.vue?vue&type=script&lang=js"
export * from "./PreActionOffers.vue?vue&type=script&lang=js"

import "./PreActionOffers.vue?vue&type=style&index=0&id=d0f970e4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f970e4"]])

export default __exports__